import { serviceAxiosInstance } from '../config/api.service.config';
import { ENDPOINTS } from '../constants/endpoints';

export function saveInvoice(invoiceData) {
  return serviceAxiosInstance.post(ENDPOINTS['SAVE_INVOICE_DATA'], invoiceData);
}
